import React from "react";
import { connect } from "react-redux";
import { ThunkDispatch } from "redux-thunk";
import { TagButton } from "cm-component-library/lib/CMLayout/Navbar/";
import { IAppState } from "../../Common";
import {
  AdvancedSearchAction,
  toggleAdvancedSearchDropdown
} from "../Actions/AdvancedSearchActions";

type StateProps = {
  isDropdownShowing: boolean;
};

type DispatchProps = {
  toggleAdvancedSearchDropdown: () => void;
};

function mapStateToProbs(state: IAppState): StateProps {
  return {
    isDropdownShowing: state.advancedSearch.isAdvancedSearchDropdownShowing
  };
}

function mapDispatchToProps(
  dispatch: ThunkDispatch<IAppState, {}, AdvancedSearchAction>
): DispatchProps {
  return {
    toggleAdvancedSearchDropdown: () => dispatch(toggleAdvancedSearchDropdown())
  };
}

class AdvancedSearchToggleButton extends React.Component<StateProps & DispatchProps> {
  constructor(props: StateProps & DispatchProps) {
    super(props);

    this.onToggle = this.onToggle.bind(this);
  }

  onToggle() {
    this.props.toggleAdvancedSearchDropdown();
  }

  render() {
    return (
      <TagButton
        title="Advanced Search"
        isActive={this.props.isDropdownShowing}
        onClick={this.onToggle}
      />
    );
  }
}

export default connect(
  mapStateToProbs,
  mapDispatchToProps
)(AdvancedSearchToggleButton);
